import React from 'react';
import { Flex, Text } from 'rebass';
import { IoIosClose } from 'react-icons/io';

const Warning = ({ message, onClose, sx = {
    position: 'relative',
    top: "60px",
    left: "50%",
    gap: '10px',
    transform: 'translate(-50%, -50%)',
} }) => {
    return <Flex
        justifyContent="center"
        align-items="center"
        sx={{
            padding: '10px 15px',
            borderRadius: '30px',
            background: '#FFB2B7',
            width: 'max-content',
            ...sx,
        }}>
        {onClose && <Text as={IoIosClose} sx={{ cursor: 'pointer' }} color="#0E0E0E" size={24} onClick={onClose} />}
        <Text
            fontFamily="Poppins"
            fontSize={16}
            lineHeight="150%"
            color="#0D0D0D"
            letter-spacing="-0.32px"
            sx={{ fontWeight: 500 }}
        >
            {message}
        </Text>
    </Flex>
}


export default Warning;